import React from "react";
import SurveyForm from "../../components/Survey/SurveyForm";

function SurveyCreate() {
  return <SurveyForm mode="create" />;
}

export default SurveyCreate;
